import { styled } from "@mui/material/styles";

export const Image = styled("img")(({ theme }) => ({
  width: "100%",
  height: "100%",
  objectFit: "cover",
  objectPosition: "center",
  cursor: "zoom-in"
}));
